import { amplitude } from "@eis-poc/lib-discover-medical-mfes";

export const EVENTS = {
  navigationClicked: "Navigation Item - clicked",
  bookmarkedItemClicked: "Bookmarks - clicked",
};

export const AFFORDANCE = {
  mainMenu: "main-menu",
  results: "results",
};

export const NAVIGATE_TO = {};

export const logNavigationClicked = ({
  affordance,
  navigateTo,
  navigateFrom,
}) => {
  const location =
    typeof window !== "undefined" ? window.location.pathname : "";

  amplitude.log(EVENTS.navigationClicked, {
    affordance: affordance,
    navigate_to: navigateTo,
    navigate_from: navigateFrom,
    location,
  });
};

export const logBookmarkedItemClicked = ({ title, record_an }) => {
  amplitude.log(EVENTS.bookmarkedItemClicked, {
    title,
    record_an,
  });
};
